import { Search, User, Globe, Menu } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { AuthService } from '../../handling_data/services/AuthService';
import { MediaNotificationCenter } from '../media/MediaNotificationCenter';

interface HeaderProps {
    onMenuClick: () => void;
}

export const Header: React.FC<HeaderProps> = ({ onMenuClick }) => {
    const { t, i18n } = useTranslation('common');
    const admin = AuthService.getCurrentUser();

    const toggleLanguage = () => {
        const newLang = i18n.language === 'ar' ? 'tr' : 'ar';
        i18n.changeLanguage(newLang);
        document.dir = newLang === 'ar' ? 'rtl' : 'ltr';
    };

    return (
        <header className="h-20 bg-white border-b border-v3-border px-4 md:px-8 flex items-center justify-between z-20 sticky top-0 shadow-sm">
            {/* Mobile Menu Toggle */}
            <button
                onClick={onMenuClick}
                className="p-2 -ml-2 mr-2 text-v3-text-secondary hover:text-primary md:hidden"
            >
                <Menu className="w-6 h-6" />
            </button>

            {/* Search Bar */}
            <div className="flex-1 max-w-md relative hidden md:block">
                <Search className={`w-5 h-5 text-v3-text-secondary absolute top-3 ${i18n.language === 'ar' ? 'right-3' : 'left-3'}`} />
                <input
                    type="text"
                    placeholder={t('search')}
                    className={`w-full py-2.5 rounded-xl border border-v3-border bg-v3-bg focus:outline-none focus:ring-2 focus:ring-accent/20 focus:border-accent transition-all text-sm ${i18n.language === 'ar' ? 'pr-10 pl-4' : 'pl-10 pr-4'}`}
                />
            </div>

            {/* Right Actions */}
            <div className="flex items-center gap-4">
                <button
                    onClick={toggleLanguage}
                    className="flex items-center gap-2 px-3 py-2 rounded-lg hover:bg-v3-bg text-v3-text-secondary hover:text-primary transition-colors font-medium text-sm border border-transparent hover:border-v3-border"
                >
                    <Globe className="w-5 h-5" />
                    <span>{i18n.language === 'ar' ? 'Türkçe' : 'العربية'}</span>
                </button>

                <MediaNotificationCenter />

                <div className="w-px h-8 bg-v3-border mx-2"></div>

                <div className="flex items-center gap-3 cursor-pointer p-1.5 pr-2 pl-4 rounded-full hover:bg-v3-bg transition-all border border-transparent hover:border-v3-border">
                    <div className="w-10 h-10 bg-primary/10 rounded-full flex items-center justify-center text-primary border border-primary/20">
                        <User className="w-5 h-5" />
                    </div>
                    <div className="hidden md:block text-right">
                        <p className="text-sm font-bold text-v3-text">{admin?.name || 'المدير العام'}</p>
                        <p className="text-xs text-v3-text-secondary">{admin?.email || 'admin@example.com'}</p>
                    </div>
                </div>
            </div>
        </header>
    );
};
